<template>
	<div>
		<component v-for="report in params.reports"
				   :key="report"
				   :is-printing="true"
				   :is="report"
				   :dataQuery="dataQuery"></component>
	</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import MarketAnalysis from '@/modules/neodash/containers/market-analysis/index.vue';

  import {httpMixin, momentMixin} from '@/modules/neodash/mixins';

  import {PRINT_GET_PARAMS} from '@/store/modules/print/types';

  export default {
    mixins: [httpMixin, momentMixin],

    computed: {
      ...mapGetters({
        params: PRINT_GET_PARAMS
      }),

      dataQuery() {
        return {
          ...this.params.filters,
          name: this.params.reportName
        };
      }
    },

    mounted() {
      this.enableLoading();
      setTimeout(() => {
        this.disableLoading();
      }, 10000);
      $('<style>@page { size: landscape; }</style>').appendTo(document.head);
    },

    components: {
      MarketAnalysis
    }
  };
</script>
